import React, { useState } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { randomString } from '../../utilities/randomString.js';
import { multiplier } from '../../utilities/multiplier.js';
import { CssAnimation } from './CssAnimation.jsx';

export function LoadingCharacters(props) {

  const { character, modifier, classes, length, animation } = props;
  const [triggerDepValue, setTriggerDepValue] = useState(null);
  const block = 'c-loading-characters';

  function retriggerAnimations() {
    setTriggerDepValue(randomString());
  };

  const characterMarkup = index => (
    <CssAnimation
    key={index}
    enter={{ ...animation, delay: `${multiplier(index, 0.5)}, hidden` }}
    triggerEnter={true}
    retrigger={triggerDepValue}
    {...( index === length - 1 && { onEnterEnd: retriggerAnimations })}
    >
      <span className={
        classNames({
        [`${block}__character`]: true,
        [`${block}__character--${modifier}`]: modifier,
        [classes]: classes
        })
      }>
        { typeof character === 'function' ? character() : character }
      </span>
    </CssAnimation>
  );

  return (
    <span className={block}>
      { [...Array(length).fill('')].map((_, index) => characterMarkup(index)) }
    </span>
  )
};

LoadingCharacters.defaultProps = {
  character: '.',
  length: 3,
  animation: { name: 'fade-in', duration: 0.5 }
};

LoadingCharacters.propTypes = {
  character: propTypes.any,
  modifier: propTypes.string,
  classes: propTypes.string,
  length: propTypes.number,
  animation: propTypes.object
};
